import React, { Component } from 'react';
import { DropdownButton } from 'react-bootstrap';
import { MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { deleteSelectedMediaIfOK, showAddSkillDetailsModal, fetchMediaIfOK } from '../../actions';
import { AddSkillDetailsModalController } from '../addSkillDetailsModal';

class SkillDetailsSegment extends Component {
    render() {
        const { showAddSkillDetailsModal, inScene } = this.props;
        return [
            <DropdownButton
                bsStyle='default'
                title='Skill Details'
                key='skill-1'
                id='skill-dropdown-basic1'
            >
                <MenuItem eventKey="1" disabled={!inScene} onClick={() => showAddSkillDetailsModal()}>
                    <i className="fas fa-plus"></i>&nbsp; New
                </MenuItem>
            </DropdownButton>,
            <AddSkillDetailsModalController key='addskilldetailsmodal' />
        ];
    }
}

const mapStateToProps = state => {
    return {
        scene: state.scene.current
    };
};

const mapDispatchToProps = {
    deleteSelectedMediaIfOK,
    showAddSkillDetailsModal,
    fetchMediaIfOK
};

SkillDetailsSegment.propTypes = {
    inScene: PropTypes.bool.isRequired,
    anySelected: PropTypes.bool.isRequired,
    scene: PropTypes.string,
    deleteSelectedMediaIfOK: PropTypes.func.isRequired,
    showAddSkillDetailsModal: PropTypes.func.isRequired,
    fetchMediaIfOK: PropTypes.func.isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SkillDetailsSegment);



// WEBPACK FOOTER //
// ./src/components/actionBar/SkillDetailsSegment.js